import { render, staticRenderFns } from "./S3Image.vue?vue&type=template&id=b14d36ae&scoped=true&"
import script from "./S3Image.vue?vue&type=script&lang=js&"
export * from "./S3Image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14d36ae",
  null
  
)

export default component.exports